module.exports = __webpack_public_path__ + "static/media/IMG_5329-min.63e3a0c6.jpg";